import React,{useState} from 'react';
import ReadMore from '../ReadMore'

function Description({description}) {
    const [showMoreDescription, setShowMoreDescription] = useState(false)

    return (
        <div className="flex flex-col">
            <div className="flex flex-row items-center text-violet-700 font-black text-base md:text-lg mb-4">
                درباره هنرمند
            </div>
            <ReadMore data={description}/>
        </div>
    );
}

export default Description;